import React from 'react';

import { Cell, List } from 'ui-builder';
import { GridLayout, GridLayoutTheme, Accordion } from 'features/nekst-widgets';
import { DetailFieldName, PriceFieldValue } from './DetailFieldCells';
import { ProjectDetailFieldRow } from './types';
import EditableFieldCell from './EditableFieldCell';

export default function FinancialFieldsBlock(props: { fields: ProjectDetailFieldRow[] }) {
  return (
    <Accordion
      title="Financial"
      count={props.fields.length}
      defaultOpen
      sectionId="financial"
      pageContext="transaction-detail"
    >
      <List
        getDataFunc={async () => props.fields}
        dependencies={[JSON.stringify(props.fields)]}
      >
        <GridLayout
          theme={GridLayoutTheme.LIGHT}
          weights={[1, 1]}
          noDataMessage="No financial fields."
        >
          <Cell label="Detail" isCentered={false}>
            <DetailFieldName />
          </Cell>
          <Cell label="Value" isCentered={false}>
            <EditableFieldCell>
              <PriceFieldValue />
            </EditableFieldCell>
          </Cell>
        </GridLayout>
      </List>
    </Accordion>
  );
}
